
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SoStatusMstApi } from '../../api/master/sostatus-mst.api';
import { SoStatusMst, SoStatusMstData } from '../../interface/master/sostatus-mst';

@Injectable()
export class SoStatusMstService extends SoStatusMstData {

  constructor(private api: SoStatusMstApi) {
    super();
  }
  list(url: string): Observable<SoStatusMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<SoStatusMst>{
      return this.api.getById(url);
  }
  create(url: string, data:SoStatusMst): Observable<SoStatusMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:SoStatusMst): Observable<SoStatusMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
